import Forgot from './ForgotPassword';
import LinkSent from './LinkSent';
import Reset from './ResetPassword';
import Success from './ResetSuccess';

const Password = { Forgot, LinkSent, Reset, Success };
export default Password;
